// PR perbaikan admin Chat (INSTRUKSI 05/11/2026): satu saringan untuk semua pesan error yang tampil di layar. Tanpa impor axios, supaya tes yang
// meniru lib/api tetap memakai saringan yang sama. Jangan menguraikan objek galat ke layar: seluruh `config` axios memuat header Authorization.
export const TEKS_UMUM = "Terjadi kesalahan. Coba lagi.";

// Teks yang memuat token, pasangan nama-nilai rahasia, hasil uraian objek axios (mis. JSON.stringify(e), pesan Error), atau bingkai stack.
// Kata biasa ("Token kedaluwarsa", "config toko") tetap boleh.
const POLA_TEKS_RAHASIA = new RegExp([
  "\\bBearer\\s+\\S",
  "[\"']?\\b(?:authorization|cookie|set-cookie|x-api-key|api[_-]?key|access_token|refresh_token|token|secret|password|sandi)\\b[\"']?\\s*[:=]\\s*\\S",
  "\\beyJ[\\w-]{10,}\\.[\\w-]+\\.[\\w-]+",
  "[\"'](?:isAxiosError|config|headers|stack)[\"']\\s*:",
  "\\bat\\s+(?:\\S+\\s+)?\\(?(?:https?|webpack|file):[^\\s)]*:\\d+:\\d+",
  "@(?:https?|webpack|file):[^\\s)]*:\\d+:\\d+",
].join("|"), "i");
export const teksAman = (t) => (typeof t === "string" && POLA_TEKS_RAHASIA.test(t) ? TEKS_UMUM : t);

const KUNCI_OBJEK_GALAT = ["config", "headers", "request", "response", "stack", "isAxiosError"];
/** Objek galat/HTTP (axios, Error), bukan detail API. */
export function objekGalat(x) {
  if (!x || typeof x !== "object") return false;
  try {
    if (x instanceof Error || Object.prototype.toString.call(x) === "[object Error]" || typeof x.toJSON === "function") return true;
    if (typeof x.name === "string" && typeof x.message === "string") return true;
    return !Array.isArray(x) && KUNCI_OBJEK_GALAT.some((k) => k in x);
  } catch { return true; }
}
function memuatObjekGalat(x, terlihat = new WeakSet()) {
  if (!x || typeof x !== "object" || terlihat.has(x)) return false;
  terlihat.add(x);
  try { return objekGalat(x) || Object.values(x).some((v) => memuatObjekGalat(v, terlihat)); } catch { return true; }
}
const uraikan = (x) => {
  if (memuatObjekGalat(x)) return TEKS_UMUM;
  try { return teksAman(JSON.stringify(x)); } catch { return TEKS_UMUM; }
};
function teksDetail(detail) {
  if (detail == null) return TEKS_UMUM;
  if (typeof detail === "string") return teksAman(detail);
  if (objekGalat(detail)) return TEKS_UMUM;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" && !objekGalat(e) ? teksAman(e.msg) : uraikan(e)))
      .filter(Boolean)
      .join(" ");
  if (typeof detail === "object") return typeof detail.msg === "string" ? teksAman(detail.msg) : uraikan(detail);
  return String(detail);
}
/** Tidak pernah kosong, supaya pola `pesan(detail) || err.message` di pemanggil tidak jatuh ke pesan mentah. */
export function formatApiErrorDetail(detail) {
  const t = teksDetail(detail);
  return typeof t === "string" && t.trim() ? t : TEKS_UMUM;
}
